import { useMutation, useQueryClient } from '@tanstack/react-query'
import { invalidateQueriesByRootKey } from '@/integrations/react-query'
import { useAppSelector } from '@/redux/hooks'
import {
  getV1WorkOrdersByIdQueryKey,
  getV1WorkOrdersLateOrdersQueryKey,
  getV1WorkOrdersQueryKey,
  patchV1RepairPartsStatusMutation,
  postV1WorkOrdersByIdRepairPartsSendToPaintMutation,
} from '../client/@tanstack/react-query.gen'

// Send/receive change the work order's currentStates (the paint column appears), so both the
// board list query and the single work-order detail query must be invalidated.
const useInvalidateWorkOrders = (workOrderId: string) => {
  const queryClient = useQueryClient()
  const activeWorkshopId = useAppSelector(state => state.settings.activeWorkshopId)

  return () => {
    queryClient.invalidateQueries({
      queryKey: getV1WorkOrdersQueryKey({
        query: { limit: 0, page: 1, workshop: activeWorkshopId },
      }),
      exact: false,
    })
    queryClient.invalidateQueries({
      queryKey: getV1WorkOrdersByIdQueryKey({ path: { id: workOrderId } }),
    })
    invalidateQueriesByRootKey(queryClient, [getV1WorkOrdersLateOrdersQueryKey])
  }
}

export const useSendRepairPartsToPaint = (workOrderId: string) => {
  const invalidate = useInvalidateWorkOrders(workOrderId)
  return useMutation({
    ...postV1WorkOrdersByIdRepairPartsSendToPaintMutation(),
    onSettled: invalidate,
  })
}

export const useUpdateRepairPartsStatus = (workOrderId: string) => {
  const invalidate = useInvalidateWorkOrders(workOrderId)
  return useMutation({
    ...patchV1RepairPartsStatusMutation(),
    onSettled: invalidate,
  })
}
